/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Fokus_S3Inputs */

const en_tut_fokus_s3 = /** @type {(inputs: Tut_Fokus_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**Jeda** and **Lanjut** are available to whoever started the session and to area managers. Focus zones stay silent in every phase.`)
};

const id_tut_fokus_s3 = /** @type {(inputs: Tut_Fokus_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**Jeda** dan **Lanjut** tersedia bagi pemulai sesi dan pengelola area. Zona fokus tetap sunyi di semua fase.`)
};

/**
* | output |
* | --- |
* | "**Jeda** and **Lanjut** are available to whoever started the session and to area managers. Focus zones stay silent in every phase." |
*
* @param {Tut_Fokus_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_fokus_s3 = /** @type {((inputs?: Tut_Fokus_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Fokus_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_fokus_s3(inputs)
	return en_tut_fokus_s3(inputs)
});